
import Popper from 'vue-popperjs'

export default {
  components: {
    Popper
  },
  props: {
    placement: {
      type: String,
      required: false,
      default: 'top'
    },
    trigger: {
      type: String,
      required: false,
      default: 'hover'
    }
  }
}
